import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { apiConstants } from '../../../_constants/api.constants';

class SideBar extends Component {

    render() {
        const { siteConstants } = this.props.language;
        const { authentication } = this.props;
        let userData = '';
        if (authentication.user !== undefined) {
            if (authentication.user.role_type !== undefined) { userData = authentication.user }
            else { userData = JSON.parse(authentication.user); }
        }

        return (
            <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

                <a className="sidebar-brand d-flex align-items-center justify-content-center" href="javascript:void(0)">
                    <div className="sidebar-brand-icon rotate-n-15">
                        <i className="fas fa-laugh-wink"></i>
                    </div>
                    <div className="sidebar-brand-text mx-3">{siteConstants.SITE_NAME}</div>
                </a>

                <hr className="sidebar-divider my-0" />

                <li className="nav-item active">
                    <Link className="nav-link" to="/dashboard"><i className="fas fa-fw fa-tachometer-alt"></i> <span>{siteConstants.MENU_DASHBOARD}</span></Link>
                </li>


                <hr className="sidebar-divider" />
                {/* show sidebar menu based on condition if user is admin/shopkeeper */}

                {
                    userData !== undefined &&
                        userData !== null &&
                        userData.role_type !== undefined &&
                        userData.role_type.length > 0 &&
                        userData.role_type[0] === 'admin' ?
                        <React.Fragment>


                            {/* <li className="nav-item">
                    <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>{siteConstants.GEN_USERS}</span>
                    </a>
                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            <Link className="collapse-item" to="/users">{siteConstants.MENU_USER_LIST}</Link>
                            <Link className="collapse-item" to="/driver-users">{siteConstants.MENU_DRIVER_LIST}</Link>
                        </div>
                    </div>
                </li>  */}



                            {/* <li className="nav-item">
                    <Link className="nav-link" to="/commission-settings"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_COMMISSION_SETTING}</span></Link>
                </li>

                 <li className="nav-item">
                    <Link className="nav-link" to="/document-verification"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_DOCUMENT_VERIFICATION}</span></Link>
                </li>  */}


                            <li className="nav-item">
                                <Link className="nav-link" to="/users"> <i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_USER_LIST}</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/shopkeeper"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_SHOPKEEPER}</span></Link>
                            </li>

                            {/* <li className="nav-item">
                    <Link className="nav-link" to="/orders"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_ORDERS}</span></Link>
                </li> */}

                            <li className="nav-item">
                                <Link className="nav-link" to="/orders"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_ORDERS}</span></Link>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseOrder" aria-expanded="true" aria-controls="collapseOrder">
                                    <i className="fas fa-fw fa-cog"></i>
                                    <span>{siteConstants.MENU_ORDERS}</span>
                                </a>
                                <div id="collapseOrder" className="collapse" aria-labelledby="headingOrder" data-parent="#accordionSidebar">
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/orders">{siteConstants.MENU_ORDERS}</Link>
                                        <Link className="collapse-item" to="/current-orders">{siteConstants.LABEL_CURRENT_ORDER}</Link>
                                    </div>
                                </div>
                            </li> */}

                            <li className="nav-item">
                                <Link className="nav-link" to="/shop-list"> <i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_PRODUCTS}</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/categories"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_CATEGORY}</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/ideas"><i className="fas fa-fw fa-table"></i> <span>Ideas</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/contests"><i className="fas fa-fw fa-table"></i> <span>Contest</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/trending"><i className="fas fa-fw fa-table"></i> <span>Trending</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/school"><i className="fas fa-fw fa-table"></i> <span>School</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/participant"><i className="fas fa-fw fa-table"></i> <span>Participant</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/coupon"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_COUPON}</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/tags"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_TAGS}</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/earnings"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.GEN_EARNINGS}</span></Link>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                    <i className="fas fa-fw fa-cog"></i>
                                    <span>{siteConstants.MENU_NOTIFICATIONS}</span>
                                </a>
                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionSidebar">
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/notifications">{siteConstants.MENU_NOTIFICATIONS}</Link>
                                        <Link className="collapse-item" to="/push-notifications">{siteConstants.MENU_PUSH_NOTIFICATIONS}</Link>
                                        <Link className="collapse-item" to="/email-notifications">{siteConstants.MENU_EMAIL_NOTIFICATIONS}</Link>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/settings"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_SETTINGS}</span></Link>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapse" aria-expanded="true" aria-controls="collapse">
                                    <i className="fas fa-fw fa-cog"></i>
                                    <span>{siteConstants.MENU_OTHERS}</span>
                                </a>
                                <div id="collapse" className="collapse" aria-labelledby="headingThree" data-parent="#accordionSidebar">
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/outlets">{siteConstants.MENU_OUTLETS}</Link>
                                    </div>
                                </div>
                            </li>

                            {/* <li className="nav-item">
                    <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                        <i className="fas fa-fw fa-cog"></i>
                        <span>{siteConstants.MENU_REPORTS}</span>
                    </a>
                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionSidebar">
                        <div className="bg-white py-2 collapse-inner rounded">
                            <Link className="collapse-item" to="/reports">{siteConstants.MENU_USER_REPORT}</Link>
                            <Link className="collapse-item" to="/revenue">{siteConstants.MENU_REVENUE}</Link>
                            <Link className="collapse-item" to="/ride">{siteConstants.MENU_RIDE}</Link>
                        </div>
                    </div>
                </li>  */}



                        </React.Fragment>
                        : ''

                }


                {
                    userData !== undefined &&
                        userData !== null &&
                        userData.role_type !== undefined &&
                        userData.role_type.length > 0 &&
                        userData.role_type[0] === 'shopkeeper' ?
                        <React.Fragment>

                            <li className="nav-item">
                                <Link className="nav-link" to="/shopkeeper-products"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_PRODUCTS}</span></Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/shop-discounts"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_DISCOUNTS}</span></Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link" to="/orders"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_ORDERS}</span></Link>
                            </li> */}

                            {/*}<li className="nav-item">
                                <Link className="nav-link" to="/coupon"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_COUPON}</span></Link>
                            </li>*/}

                            <li className="nav-item">
                                <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseOrder" aria-expanded="true" aria-controls="collapseOrder">
                                    <i className="fas fa-fw fa-cog"></i>
                                    <span>{siteConstants.MENU_ORDERS}</span>
                                </a>
                                <div id="collapseOrder" className="collapse" aria-labelledby="headingOrder" data-parent="#accordionSidebar">
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/orders">{siteConstants.MENU_ORDERS}</Link>
                                        <Link className="collapse-item" to="/current-orders">{siteConstants.LABEL_CURRENT_ORDER}</Link>
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/coupon"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_COUPON}</span></Link>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link collapsed" href="javascript:void(0)" data-toggle="collapse" data-target="#collapseEarnings" aria-expanded="true" aria-controls="collapseEarnings">
                                    <i className="fas fa-fw fa-cog"></i>
                                    <span>{siteConstants.GEN_EARNINGS}</span>
                                </a>
                                <div id="collapseEarnings" className="collapse" aria-labelledby="headingEarnings" data-parent="#accordionSidebar">
                                    <div className="bg-white py-2 collapse-inner rounded">

                                        <Link className="collapse-item" to={"/shop-earnings/"+userData._id+"/cod"}>{siteConstants.GEN_COD_EARNINGS}</Link>
                                        <Link className="collapse-item" to={"/shop-earnings/"+userData._id+"/card"}>{siteConstants.GEN_OTHER_EARNINGS}</Link>
                                    </div>
                                </div>
                            </li>

                        </React.Fragment>
                        : ''

                }










                <hr className="sidebar-divider" />

                <li className="nav-item">
                    <Link className="nav-link" to="/login"><i className="fas fa-fw fa-table"></i> <span>{siteConstants.MENU_LOGOUT}</span></Link>
                </li>

            </ul>

        );
    }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, authentication } = state;
    return {
        language, authentication
    };
}

const connectedSideBar = connect(mapStateToProps)(SideBar);
export default connectedSideBar;
